import { render, staticRenderFns } from "./RichTextV2.vue?vue&type=template&id=5f96158f&scoped=true&"
import script from "./RichTextV2.vue?vue&type=script&lang=ts&"
export * from "./RichTextV2.vue?vue&type=script&lang=ts&"
import style0 from "./RichTextV2.vue?vue&type=style&index=0&id=5f96158f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f96158f",
  null
  
)

export default component.exports